import { useSelector } from "react-redux";

export const useParentKidAuth = () => {
  const parentkidUser = useSelector((state) => state.parentKidAuth?.parentKidUser);
  return {
    isAuthenticated: !!parentkidUser,
    parentkidUser,
  };
};